import React from 'react';

const Pagination = ({ pagination, onPageChange }) => {
  if (!pagination || pagination.last_page <= 1) return null;

  const { current_page, last_page, total, from, to } = pagination;

  const renderPageButtons = () => {
    const buttons = [];
    const maxVisible = 5;

    let startPage = Math.max(1, current_page - Math.floor(maxVisible / 2));
    let endPage = Math.min(last_page, startPage + maxVisible - 1);

    if (endPage - startPage + 1 < maxVisible) {
      startPage = Math.max(1, endPage - maxVisible + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          onClick={() => onPageChange(i)}
          className={`px-3 py-1.5 text-sm font-bold rounded-lg transition ${
            current_page === i
              ? 'bg-blue-600 text-white shadow-md'
              : 'border border-gray-300 hover:bg-gray-100 text-gray-700 bg-white'
          }`}
        >
          {i}
        </button>
      );
    }

    return buttons;
  };

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between bg-gray-50 px-6 py-4 border-t border-gray-200 gap-4">
      <div className="text-sm text-gray-500 font-medium order-2 sm:order-1">
        Menampilkan <span className="text-gray-900 font-bold">{from || 0}</span> - <span className="text-gray-900 font-bold">{to || 0}</span> dari <span className="text-gray-900 font-bold">{total}</span> data
      </div>
      
      <div className="flex items-center gap-1.5 order-1 sm:order-2">
        <button
          onClick={() => onPageChange(1)}
          disabled={current_page === 1}
          className="p-1.5 text-sm font-bold border border-gray-300 rounded-lg disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-100 transition bg-white"
          title="Halaman Pertama"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
          </svg>
        </button>
        
        <button
          onClick={() => onPageChange(current_page - 1)}
          disabled={current_page === 1}
          className="p-1.5 text-sm font-bold border border-gray-300 rounded-lg disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-100 transition bg-white"
          title="Halaman Sebelumnya"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <div className="flex gap-1 mx-1">
          {renderPageButtons()}
        </div>

        <button
          onClick={() => onPageChange(current_page + 1)}
          disabled={current_page === last_page}
          className="p-1.5 text-sm font-bold border border-gray-300 rounded-lg disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-100 transition bg-white"
          title="Halaman Selanjutnya"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
        
        <button
          onClick={() => onPageChange(last_page)}
          disabled={current_page === last_page}
          className="p-1.5 text-sm font-bold border border-gray-300 rounded-lg disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-100 transition bg-white"
          title="Halaman Terakhir"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 5l7 7-7 7M5 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Pagination;
